"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const config_1 = require("config");
const React = require("react");
require("./footer.scss");
const Translate_1 = require("./Translate");
const View_1 = require("./View");
class Footer extends React.PureComponent {
    render() {
        const { className = "footer", disclaimer, onLinkClick } = this.props;
        return (React.createElement("div", { className: className, role: "contentinfo" },
            React.createElement(View_1.View, { className: "centered" },
                React.createElement("a", { href: config_1.default.urls.absoluteUrls.privacyStatement, target: "_blank", rel: "noopener noreferrer", onClick: onLinkClick },
                    React.createElement(Translate_1.Translate, { i18n: "txt_link_footer_privacy_and_cookies" })),
                React.createElement("a", { href: "attribution.txt", target: "_blank", rel: "noopener noreferrer", onClick: onLinkClick },
                    React.createElement(Translate_1.Translate, { i18n: "txt_link_footer_third_party_disclosures" })),
                disclaimer ? React.createElement("span", null,
                    " | ",
                    React.createElement(Translate_1.Translate, { i18n: disclaimer })) : null)));
    }
}
exports.Footer = Footer;
